import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { KeywordLabel } from '../ui-parts/KeywordLabel';

export default function TooltipKeywordLabel(props) {
  const { title, toolTipValue, keyword, value, fontSize, ...other } = props;

  return (
    <Tooltip title={toolTipValue} color="neutral" size="lg" arrow>
      <Box>
        <KeywordLabel keyword={keyword} value={value} fontSize={fontSize} {...other} />
      </Box>
    </Tooltip>
  );
}